/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".vs-file-viewer .ui-lightbox-nav-left,.vs-file-viewer .ui-lightbox-nav-right{padding:20px;background-color:#00000036}.vs-file-viewer .ui-dialog-content{padding:0!important}"];
export { styles as styles };
